<template>
    <ArboTabs
        :value="currentSearchTab"
        :tabs="tabs"
        :size="'small'"
        :type="'tertiary'"
        class="global-search-tabs arbo-ui-styles"
        @input="(val: SearchType) => (currentSearchTab = val)">
        <template #recent_accessed>
            <ListSearchRecent v-if="currentSearchTab == 'recent_accessed'" id="recent-accessed" />
        </template>
        <template #people>
            <ListSearchPeople v-if="currentSearchTab == 'people'" id="people" />
        </template>
        <template #entity>
            <ListSearchProject v-if="currentSearchTab == 'entity'" id="project" />
        </template>
        <template #item>
            <ListSearchScene v-if="currentSearchTab == 'item'" id="scene" />
        </template>
    </ArboTabs>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';

import { useGlobalSearchStore } from 'src/stores';
import ListSearchPeople from 'src/views/ListSearchPeople.vue';
import { storeToRefs } from 'pinia';
import ListSearchProject from 'src/views/ListSearchProject.vue';
import ListSearchScene from 'src/views/ListSearchScene.vue';
import type { SearchType } from 'src/types';
import { useApi } from 'src/stores/useApis';
import ListSearchRecent from 'src/views/ListSearchRecent.vue';
import { getTerminology } from 'src/plugins/terminology';

const tabs = computed<{ id: SearchType; value: SearchType; name: string }[]>(() => {
    return [
        { name: 'Recent', id: 'recent_accessed', value: 'recent_accessed' },
        { name: 'People', value: 'people', id: 'people' },
        { name: getTerminology({ code: 'scene' }), value: 'item', id: 'item' },
        { name: getTerminology({ code: 'project' }), id: 'entity', value: 'entity' }
    ];
});
const globalSearchStore = useGlobalSearchStore();
const { currentSearchTab, currentPage, isSearching } = storeToRefs(globalSearchStore);
const apiStore = useApi();
const handleTabChange = async (tab: SearchType) => {
    currentPage.value = 0;
    isSearching.value = true;
    await apiStore.cancelAllRequests();
    await globalSearchStore.clearResult();
    currentSearchTab.value = tab;
};

watch(currentSearchTab, handleTabChange);
</script>
<style lang="scss">
.global-search-main .arbo-tabs__label,
.tess-more-action-menu .arbo-tabs__label {
    --bg-inactive-color: #a3d4f5;
}
</style>
